module.exports = __webpack_public_path__ + "img/910-ff6006.png";